import axios from '../../axios'

/**
 * todo 获取商品页面分类
 */
function pagecategory(params) {
  return axios.get(`/category/pagecategory`, params)
}

/**
 * todo 商品分类
 * @param {pageCategoryId: 页面分类id}
 */
function goodcategory(params, config) {
  return axios.get(`/category/goodcategory`, params, config)
}

/**
 * todo 商品列表
 * @param {pageCategoryId: 页面分类id, goodsCategoryId: 页面分类id, pageNo: 页码, pageSize: 每页数量 写大些 1次性加载}
 */
function getlist(params, config) {
  return axios.get(`/goods/getlist`, params, config)
}

/**
 * todo 商品详情
 * @param {id: 商品id}
 */
function detail(params) {
  return axios.get(`/goods/detail`, params)
}

/**
 * todo 获取零售商品及库存信息
 * @param {goodsId: 商品id, saleDate: 销售日期 查询指定某一天的库存}
 */
function retailGoodsStock(params) {
  return axios.get(`/goods/retailGoodsStock`, params)
}

/**
 * todo 获取用户零售商品订阅订单信息 判断是否有订阅信息
 * @param {goodsId: 商品id}
 */
function getRetailGoodsSubscribeOrderInfo(params) {
  return axios.get(`/goods/getRetailGoodsSubscribeOrderInfo`, params)
}

/**
 * todo 订阅零售商品
 * @param {goodsId: 商品id, userName: 用户名, phone: 电话, address: 地址, orderInfo: 订阅信息}
 */
function orderRetailGoods(params) {
  return axios.post('/goods/orderRetailGoods', params)
}

/**
 * todo 查询订阅生成的订单信息
 * @param {goodsId: 商品id, userName: 用户名, phone: 电话, address: 地址, orderInfo: 订阅信息}
 */
function getRetailGoodsOrderInfo(params) {
  return axios.get(`/goods/getRetailGoodsOrderInfo`, params)
}

/**
 * todo 提交零售商品订单
 * @param {orderInfo: 订单信息, subOrderInfos: 子订单信息, totalPrice: 总价格}
 */
function submitRetailGoodsOrder(params) {
  return axios.post(`/goods/submitRetailGoodsOrder`, params)
}

/**
 * todo 非零售类商品提交订单
 * @param {goodsid: 非零售类商品id, goodsnumber: 商品数量, ... cardid: 报卡编号, totalprice: 订单总金额}
 */
function submitNoRetailGoodsOrder(params) {
  return axios.post(`/goods/submitNoRetailGoodsOrder`, params)
}

/**
 * todo 报卡校验
 * @param {goodsid: 非零售类商品id, cardId: 报卡id}
 */
function checkCardId(params) {
  return axios.get(`/goods/checkCardId`, params)
}

export default {
  orderRetailGoods,
  pagecategory,
  goodcategory,
  getlist,
  detail,
  retailGoodsStock,
  getRetailGoodsSubscribeOrderInfo,
  getRetailGoodsOrderInfo,
  submitRetailGoodsOrder,
  submitNoRetailGoodsOrder,
  checkCardId
}
